var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_270_54977)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H16V12H0V0Z",
    fill: "#E31D1C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55698 4.87762L1.61033 6.40334L2.35366 4.09603L1.05548 2.89627L2.81328 2.83139L3.55698 0.974182L4.30067 2.83139H6.05548L4.7603 4.09603L5.35031 6.40334L3.55698 4.87762Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50817 3.08591L6.69131 3.57905L6.87763 2.61674L6.19739 1.89654L7.11848 1.8576L7.50817 0.959045L7.89787 1.8576H8.81739L8.13871 2.61674L8.34303 3.57905L7.50817 3.08591Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50817 5.08591L7.69131 5.57905L7.87763 4.61674L7.19739 3.89654L8.11848 3.8576L8.50817 2.95905L8.89787 3.8576H9.81739L9.13871 4.61674L9.34303 5.57905L8.50817 5.08591Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50817 7.08591L6.69131 7.57905L6.87763 6.61674L6.19739 5.89654L7.11848 5.8576L7.50817 4.95905L7.89787 5.8576H8.81739L8.13871 6.61674L8.34303 7.57905L7.50817 7.08591Z",
    fill: "#FECA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50817 8.08591L4.69131 8.57905L4.87763 7.61674L4.19739 6.89654L5.11848 6.8576L5.50817 5.95905L5.89787 6.8576H6.81739L6.13871 7.61674L6.34303 8.57905L5.50817 8.08591Z",
    fill: "#FECA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_270_54977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZh);
export default __webpack_public_path__ + "static/media/zh.3ab5605c5492a6a492085d4185c9dc74.svg";
export { ForwardRef as ReactComponent };